var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"small":"","color":"primary","disabled":_vm.disabled,"outlined":""},on:{"click":_vm.checkReservationQueueBulk}},[_vm._v("Try to reserve")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }